import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import BlueButton from "../../BlueButton/BlueButton.js";
import {word} from '../../../word.js'
import {managerUpdateRequest} from "../../../store/actions/manager.js";

const Phone = ({ close }) => {
    const [phone, setPhone] = useState("");
    const [valid, setValid] = useState(false);
    const [submit, setSubmit] = useState(false);
    const [disabled, setDisabled] = useState(false);

    const login = useSelector((state) => state.manager.employee);
    const dispatch = useDispatch();

    const keyPress = async (e) => {
        if (e.key === "Enter") {
            await submitForm();
        }
    };

    const submitForm = async () => {
        setSubmit(true);
        setDisabled(true);
        let formData = new FormData();
        if (valid) {
            formData.append("user.first_name", login.user.first_name);
            formData.append("user.last_name", login.user.last_name);
            formData.append("phone", phone);
            formData.append("user.email", login.user.email);
            await dispatch(managerUpdateRequest({form:formData}))
            close();

        } else {
            setDisabled(false);
        }
    };

    return (
        <div className="settings-item">
            <Form.Group className="justify-content-center form-group">
                <Form.Control
                    placeholder="Հեռախոսահամար"
                    className={!valid && submit ? "form-control is-invalid" : "form-control"}
                    autoComplete="off"
                    onKeyDown={keyPress}
                    onChange={(e) => {
                        let value = e.target.value;
                        let re = /^[0-9]/;
                        let isValid = re.test(value) && value[0] === "0" && value.length === 9;
                        setValid(isValid);
                        setPhone(value);
                    }}
                />
                {!valid && submit && (
                    <div className="validation valid-center">
                        <span>{word.phone_error}</span>
                    </div>
                )}
            </Form.Group>

            <BlueButton disabled={disabled} onChangeValue={submitForm} title="Հաստատել" />
        </div>
    );
};

export default Phone;
